import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0610. 発注案件メンバー削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_members/:purchase_order_member_id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  purchase_order_member_id: number;
};
export const destroyPurchaseOrderMember = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_members/${props.purchase_order_member_id}`
  );
};

export const useDestroyPurchaseOrderMember = () => {
  return useMutation({
    mutationFn: destroyPurchaseOrderMember,
  });
};
